import { get, post } from '../axios'

/* 登录
 * basePath:/login/sign/in
 * @Params:
 *   RequiredParams: [code,]
 *   ParamsBody:
 *     code:{desc:钉钉扫码返回的code}
 * @Response:
 */
export function login_sign_in_get(map) {
  // 登录
  return get(`${process.env.VUE_APP_LOGIN}/login/sign/in`, map)
}

/* 注销
 * basePath:/login/sign/out
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function login_sign_out_get(map) {
  // 注销
  return get(`${process.env.VUE_APP_LOGIN}/login/sign/out`, map)
}

/* 系统列表查询
 * basePath:/menu/system/list
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function menu_system_list_get(map) {
  // 系统列表查询
  return get(`${process.env.VUE_APP_MENU}/menu/system/list`, map)
}

/* 左侧菜单栏查询
 * basePath:/menu/tree
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function menu_tree_get(map) {
  // 左侧菜单栏查询
  return get(`${process.env.VUE_APP_MENU}/menu/tree`, map)
}

/* 菜单配置列表查询
 * basePath:/menu/list
 * @Params:
 *   RequiredParams: [parentId,menuTypeStart,menuTypeEnd,]
 *   ParamsBody:
 *     parentId:{desc:父级id}
 *     menuTypeStart:{desc:菜单树最高父级 0 系统 1 目录 2 菜单 3 按钮}
 *     menuTypeEnd:{desc:菜单树最低子级 0 系统 1 目录 2 菜单 3 按钮}
 * @Response:
 */
export function menu_list_get(map) {
  // 菜单配置列表查询
  return get(`${process.env.VUE_APP_MENU}/menu/list`, map)
}

/* 删除
 * basePath:/menu/delete
 * @Params:
 *   RequiredParams: [id,]
 *   ParamsBody:
 *     id:{type: number,description:主键}
 * @Response:
 */
export function menu_delete_post(map) {
  // 删除
  return post(`${process.env.VUE_APP_MENU}/menu/delete`, map)
}

/* 添加收藏菜单
 * basePath:/user/unfavorite-menu
 * @Params:
 *   RequiredParams: [menuId,]
 *   ParamsBody:
 *     menuId:{type: number,description:主键}
 * @Response:
 */
export function add_favorite_menu(map) {
  return post(`${process.env.VUE_APP_MENU}/user/favorite-menu`, map)
}

/* 取消收藏菜单
 * basePath:/user/unfavorite-menu
 * @Params:
 *   RequiredParams: [menuId,]
 *   ParamsBody:
 *     menuId:{type: number,description:主键}
 * @Response:
 */
export function remove_favorite_menu(map) {
  return post(`${process.env.VUE_APP_MENU}/user/unfavorite-menu`, map)
}

/* 系统列表操作（创建或修改）
 * basePath:/menu/system/operate
 * @Params:
 *   RequiredParams: [menuName,menuDesc,menuCode,menuNameEn,]
 *   ParamsBody:
 *     menuName:{type: string,description:系统名称}
 *     menuDesc:{type: string,description:系统描述}
 *     menuCode:{type: string,description:系统三字码}
 *     id:{type: number,description:主键（修改操作必填）}
 *     menuPath:{type: string,description:系统路径}
 *     menuNameEn:{type: string,description:系统英文名称}
 * @Response:
 */
export function menu_system_operate_post(map) {
  // 系统列表操作（创建或修改）
  return post(`${process.env.VUE_APP_MENU}/menu/system/operate`, map)
}

/* 菜单操作（创建或修改）
 * basePath:/menu/operate
 * @Params:
 *   RequiredParams: [parentId,menuType,menuName,]
 *   ParamsBody:
 *     parentId:{type: string,description:父节点id}
 *     menuName:{type: string,description:页面名称}
 *     menuType:{type: string,description:菜单类型，只能传入1 目录、2 菜单类型、3按钮}
 *     menuPath:{type: string,description:页面路径}
 *     menuIcon:{type: string,description:icon}
 *     id:{type: number,description:主键（修改操作必填）}
 *     menuCode:{type: string,description:菜单类型为按钮时必填}
 *     menuNameEn:{type: string,description:菜单类型为目录、菜单时必填}
 * @Response:
 */
export function menu_operate_post(map) {
  // 菜单操作（创建或修改）
  return post(`${process.env.VUE_APP_MENU}/menu/operate`, map)
}

/* 修改前查询
 * basePath:/menu/query/{id}
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function menu_query_id_get(map) {
  // 修改前查询
  return get(`${process.env.VUE_APP_MENU}/menu/query/${map.id}`, map)
}

/* 上传至oss
 * basePath:/upload/oss
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function upload_oss_post(map) {
  // 上传至oss
  return post(`${process.env.VUE_APP_UPLOAD}/upload/oss`, map)
}

/* 查询列表
 * basePath:/role/list
 * @Params:
 *   RequiredParams: [pageNum,pageSize,menuSystemId,]
 *   ParamsBody:
 *     pageNum:{desc:分页页数}
 *     pageSize:{desc:分页大小}
 *     menuSystemId:{desc:系统id（公共分类接口中获取）}
 * @Response:
 */
export function role_list_get(map) {
  // 查询列表
  return get(`${process.env.VUE_APP_ROLE}/role/list`, map)
}

/* 更新前查询
 * basePath:/role/query/{id}
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function role_query_id_get(map) {
  // 更新前查询
  return get(`${process.env.VUE_APP_ROLE}/role/query/${map.id}`, map)
}

/* 操作（新增或者更新）
 * basePath:/role/operate
 * @Params:
 *   RequiredParams: [name,menuSystemId,]
 *   ParamsBody:
 *     id:{type: number,description:更新时id必填}
 *     name:{type: string,description:角色名称}
 *     menuSystemId:{type: number,description:系统id（公共分类接口中获取）}
 * @Response:
 */
export function role_operate_post(map) {
  // 操作（新增或者更新）
  return post(`${process.env.VUE_APP_ROLE}/role/operate`, map)
}

/* 删除
 * basePath:/role/delete
 * @Params:
 *   RequiredParams: [id,]
 *   ParamsBody:
 *     id:{type: number,description:主键}
 * @Response:
 */
export function role_delete_post(map) {
  // 删除
  return post(`${process.env.VUE_APP_ROLE}/role/delete`, map)
}

/* 查询菜单配置
 * basePath:/role/query/menu
 * @Params:
 *   RequiredParams: [roleId,]
 *   ParamsBody:
 *     roleId:{desc:角色id}
 * @Response:
 */
export function role_query_menu_get(map) {
  // 查询菜单配置
  return get(`${process.env.VUE_APP_ROLE}/role/query/menu`, map)
}

/* 角色菜单注册
 * basePath:/role/create/menu
 * @Params:
 *   RequiredParams: [roleId,menuIds,]
 *   ParamsBody:
 *     roleId:{type: number,description:角色id}
 *     menuIds:{type: array,description:菜单id数组}
 *        type:{type: undefined,description:undefined}
 *        description:{type: undefined,description:undefined}
 * @Response:
 */
export function role_create_menu_post(map) {
  // 角色菜单注册
  return post(`${process.env.VUE_APP_ROLE}/role/create/menu`, map)
}

/* 基础信息查询
 * basePath:/common/info
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function common_info_get(map) {
  // 基础信息查询
  return get(`${process.env.VUE_APP_COMMON}/common/info`, map)
}

/* 查询列表
 * basePath:/user/list
 * @Params:
 *   RequiredParams: [pageNum,pageSize,name,email,title,roleId,departmentId,]
 *   ParamsBody:
 *     pageNum:{desc:分页页数}
 *     pageSize:{desc:分页大小}
 *     name:{desc:用户名称}
 *     email:{desc:邮箱}
 *     title:{desc:职位}
 *     roleId:{desc:角色id（公共分类基础接口获取）}
 *     departmentId:{desc:部门ID}
 * @Response:
 */
export function user_list_get(map) {
  // 查询列表
  return post(`${process.env.VUE_APP_USER}/user/list-post`, map)
}

/* 角色详情查询
 * basePath:/user/query/role/{id}
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function user_query_role_id_get(map) {
  // 角色详情查询
  return get(`${process.env.VUE_APP_USER}/user/query/role/${map.id}`, map)
}

/* 删除
 * basePath:/user/delete/role
 * @Params:
 *   RequiredParams: [id,]
 *   ParamsBody:
 *     id:{type: number,description:用户角色id}
 * @Response:
 */
export function user_delete_role_post(map) {
  // 删除
  return post(`${process.env.VUE_APP_USER}/user/delete/role`, map)
}

/* 批量分配
 * basePath:/user/create/role
 * @Params:
 *   RequiredParams: [userIds,roleIds,]
 *   ParamsBody:
 *     userIds:{type: array,description:用户id数组}
 *        type:{type: undefined,description:undefined}
 *     roleIds:{type: array,description:角色id数组}
 *        type:{type: undefined,description:undefined}
 * @Response:
 */
export function user_create_role_post(map) {
  // 批量分配
  return post(`${process.env.VUE_APP_USER}/user/create/role`, map)
}

/* 语言列表
 * basePath:/language/list
 * @Params:
 *   RequiredParams: [pageNum,pageSize,langEn,langCn,enabled,]
 *   ParamsBody:
 *     pageNum:{desc:分页页数}
 *     pageSize:{desc:分页大小}
 *     langEn:{desc:语言英文}
 *     langCn:{desc:语言中文}
 *     enabled:{desc:状态 (0 是 1 否)}
 * @Response:
 */
export function language_list_get(map) {
  // 语言列表
  return get(`${process.env.VUE_APP_LANGUAGE}/language/list`, map)
}

/* 查询列表
 * basePath:/export/list
 * @Params:
 *   RequiredParams: [pageNum,pageSize,]
 *   ParamsBody:
 *     pageNum:{desc:1}
 *     pageSize:{desc:10}
 * @Response:
 */
export function export_list_get(map) {
  // 查询列表
  return get(`${process.env.VUE_APP_EXPORT}/export/list`, map)
}

/* 更新备注信息
 * basePath:/export/update/remark
 * @Params:
 *   RequiredParams: [id,remark,]
 *   ParamsBody:
 *     id:{type: number,description:主键}
 *     remark:{type: string,description:备注}
 * @Response:
 */
export function export_update_remark_post(map) {
  // 更新备注信息
  return post(`${process.env.VUE_APP_EXPORT}/export/update/remark`, map)
}

/* 下载任务
 * basePath:/export/download
 * @Params:
 *   RequiredParams: [id,]
 *   ParamsBody:
 *     id:{type: number,description:主键}
 * @Response:
 */
export function export_download_post(map) {
  // 下载任务
  return post(`${process.env.VUE_APP_EXPORT}/export/download`, map)
}

/* 词条批量导入
 * basePath:/language/key/upload
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function language_key_upload_post(map) {
  // 词条批量导入
  return post(`${process.env.VUE_APP_LANGUAGE}/language/key/upload`, map)
}

/* 词条翻译关系查询
 * basePath:/language/key/map
 * @Params:
 *   RequiredParams: [systemId,languageId,]
 *   ParamsBody:
 *     systemId:{desc:系统id}
 *     languageId:{desc:语言id}
 * @Response:
 */
export function language_key_map_get(map) {
  // 词条翻译关系查询
  return get(`${process.env.VUE_APP_LANGUAGE}/language/key/map`, map)
}

/* 根据系统id查询按钮列表
 * basePath:/menu/query/button/{systemId}
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function menu_query_button_systemId_get(map) {
  // 根据系统id查询按钮列表
  return get(
    `${process.env.VUE_APP_MENU}/menu/query/button/${map.systemId}`,
    map
  )
}

/* 菜单排序
 * basePath:/menu/sort
 * @Params:
 *   RequiredParams: [sourceId,targetId,]
 *   ParamsBody:
 *     sourceId:{type: number,description:源页面id}
 *     targetId:{type: number,description:目标页面id}
 * @Response:
 */
export function menu_sort_post(map) {
  // 菜单排序
  return post(`${process.env.VUE_APP_MENU}/menu/sort`, map)
}

/* 检查接口
 * basePath:/common/check
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function common_check_get(map) {
  // 检查接口
  return get(`${process.env.VUE_APP_COMMON}/common/check`, map)
}

/* 部门组织树
 * basePath:/department/tree
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function department_tree_get(map) {
  // 部门组织树
  return get(`${process.env.VUE_APP_DEPARTMENT}/department/tree`, map)
}

/* 语言启用开关
 * basePath:/language/enable
 * @Params:
 *   RequiredParams: [id,enabled,]
 *   ParamsBody:
 *     id:{type: number,description:主键}
 *     enabled:{type: integer,description:语言状态状态 (0 是 1 否)}
 * @Response:
 */
export function language_enable_post(map) {
  // 语言启用开关
  return post(`${process.env.VUE_APP_LANGUAGE}/language/enable`, map)
}

/* 词条列表
 * basePath:/language/key/list
 * @Params:
 *   RequiredParams: [pageNum,pageSize,keyName,languageId,valueName,systemId,userName,updateTimeStart,updateTimeEnd,]
 *   ParamsBody:
 *     pageNum:{desc:分页页数}
 *     pageSize:{desc:分页大小}
 *     keyName:{desc:词条key}
 *     languageId:{desc:语言id}
 *     valueName:{desc:语言文案}
 *     systemId:{desc:归属系统}
 *     userName:{desc:更新人}
 *     updateTimeStart:{desc:更新开始时间}
 *     updateTimeEnd:{desc:更新结束时间}
 * @Response:
 */
export function language_key_list_get(map) {
  // 词条列表
  return get(`${process.env.VUE_APP_LANGUAGE}/language/key/list`, map)
}

/* 词条列表导出
 * basePath:/language/key/export
 * @Params:
 *   RequiredParams: [keyName,languageId,valueName,systemId,userName,updateTimeStart,updateTimeEnd,]
 *   ParamsBody:
 *     keyName:{desc:词条key}
 *     languageId:{desc:语言id}
 *     valueName:{desc:语言文案}
 *     systemId:{desc:归属系统}
 *     userName:{desc:更新人}
 *     updateTimeStart:{desc:更新开始时间}
 *     updateTimeEnd:{desc:更新结束时间}
 * @Response:
 */
export function language_key_export_get(map) {
  // 词条列表导出
  return get(`${process.env.VUE_APP_LANGUAGE}/language/key/export`, map)
}

/* 词条操作（新增或者修改）
 * basePath:/language/key/operate
 * @Params:
 *   RequiredParams: [keyName,systemId,]
 *   ParamsBody:
 *     id:{type: number,description:主键（更新时必填）}
 *     keyName:{type: string,description:词条名称}
 *     systemId:{type: number,description:系统id}
 *     动态列（语言列，行数不固定）:{type: string,description:根据《词条操作之前查询》列展示}
 * @Response:
 */
export function language_key_operate_post(map) {
  // 词条操作（新增或者修改）
  return post(`${process.env.VUE_APP_LANGUAGE}/language/key/operate`, map)
}

/* 语言列查询
 * basePath:/language/key/operate/lang/field
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function language_key_operate_lang_field_get(map) {
  // 语言列查询
  return get(
    `${process.env.VUE_APP_LANGUAGE}/language/key/operate/lang/field`,
    map
  )
}

/* 更新前查询
 * basePath:/language/key/query/{id}
 * @Params:
 *   RequiredParams: []
 *   ParamsBody:
 * @Response:
 */
export function language_key_query_id_get(map) {
  // 更新前查询
  return get(
    `${process.env.VUE_APP_LANGUAGE}/language/key/query/${map.id}`,
    map
  )
}
